import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdminCopyBatch,
  AdminCopyData,
  AdminCopyResponse,
  CopiesDataService,
} from '@mol-limo-reg/admin-api';
import { CopySection } from '../components/copy-management/copy-management.interfaces';

@Injectable({
  providedIn: 'root',
})
export class CopyService {
  constructor(private readonly copiesDataService: CopiesDataService) {}

  public getCopies$(limit: number, offset: number, q?: string, section?: CopySection): Observable<AdminCopyBatch> {
    return this.copiesDataService.getCopy(limit, offset, q, section, 'body');
  }

  public getCopyByKey$(copyKey: string): Observable<AdminCopyResponse> {
    return this.copiesDataService.getCopyByKey(copyKey, 'body');
  }

  public updateCopyByKey$(copyKey: string, data: AdminCopyData): Observable<any> {
    return this.copiesDataService.updateCopyByKey(copyKey, data, 'body');
  }
}
